<base-support-modal
	[title]="title"
	[isLoading]="isLoading"
	[btnOkClass]="'btn-danger'"
	[btnOkLabel]="'Сменить'"
	[form]="form"
	(onOk)="ok()"
>
	<form [formGroup]="form">
		<div
			class="alert alert-warning"
			role="alert"
			*ngIf="domains.length > 0"
		>
			<strong>Внимание!</strong>
			<br>
			К сайту прикреплены домены, купленные в <em>uKit</em>:
			<strong>{{ domains.join(', ') }}</strong>
			<br>
			Возможность управления этими доменами есть только у аккаунтов:
			<strong>{{ emails.join(', ') }}</strong>
		</div>
	
		<div class="form-group">
			<label>
				E-mail нового владельца
			</label>
			
			<input
				type="text"
				class="form-control"
				formControlName="newOwnerEmail"
				[formErrorIndicator]="form.get('newOwnerEmail')"
			/>
		</div>
	</form>
</base-support-modal>
